import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { LABS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/labs/new")({
  component: () => <DeptContentForm cfg={LABS} />,
});
